// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"130":"6053f31a","402":"9f297212"}[chunkId] + ".js";
};